import React from 'react'
import { Loading } from 'src/components'
import { useStyles } from './styles'

interface LoadingOverlayProps {
  isVisible: boolean
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isVisible }) => {
  if (!isVisible) return null

  return (
    <div className={useStyles().overlay}>
      <div className={useStyles().backdrop} />
      <div className={useStyles().loadingContainer}>
        <Loading />
      </div>
    </div>
  )
}
